/**
 * Auth card wrapper: header, optional Google button, divider, tabs, content.
 * Used for login and register pages.
 */

export default function AuthCard({ title, subtitle, onGoogle, children, className = '' }) {
  const hasGoogle = typeof onGoogle === 'function';

  return (
    <div className={`card p-8 space-y-6 ${className}`}>
      <div>
        <h2 className="text-2xl font-semibold text-gray-900 dark:text-gray-100">{title}</h2>
        <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">{subtitle}</p>
      </div>

      {hasGoogle && (
        <>
          <button
            type="button"
            onClick={onGoogle}
            className="w-full flex items-center justify-center gap-3 px-4 py-3.5 border-2 border-gray-300 dark:border-gray-600 rounded-2xl hover:border-gray-400 dark:hover:border-gray-500 transition-colors bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 font-medium shadow-sm focus:outline-none focus:ring-2 focus:ring-primary-500/50"
          >
            <img src="https://www.google.com/favicon.ico" alt="Google" className="w-5 h-5" />
            <span>Nastavi sa Google</span>
          </button>

          <div className="relative">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t border-gray-300 dark:border-gray-600" />
            </div>
            <div className="relative flex justify-center text-sm">
              <span className="px-3 bg-white dark:bg-gray-800 text-gray-500 dark:text-gray-400">ili</span>
            </div>
          </div>
        </>
      )}

      {children}
    </div>
  );
}
